import React from 'react';

const ResetPasswordContext = React.createContext(null);

export default ResetPasswordContext;
